import { gql } from "@apollo/client";

export const QUERY_FUNDING_REQUEST_BY_ME = gql`
  query MyQuery(
    $status: String
    $orderBy: [String]
    $first: Int
    $last: Int
    $before: String
    $after: String
    $userLoadNumber: String
    $debtor: String
    $loadOrInvoiceOrDebtorOrStatus: String
    $contractType: String
  ) {
    fundingRequestsByMe(
      status: $status
      orderBy: $orderBy
      first: $first
      last: $last
      before: $before
      after: $after
      userLoadNumber: $userLoadNumber
      debtor: $debtor
      loadOrInvoiceOrDebtorOrStatus: $loadOrInvoiceOrDebtorOrStatus
      contractType: $contractType
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
      data {
        created
        modified
        id
        amount
        billToAddress
        billToCompanyEmail
        billToCompanyPhone
        firstOriginLocation
        finalDestinationLocation
        loadLength
        loadTrailerType
        fundedAt
        userReferenceNumber
        userNotes
        invoiceNumber
        discountRate
        fuelAdvanceRate
        fuelAdvanceFee
        fuelAdvanceAmount
        invoiceSent
        invoiceSentCount
        lastInvoiceSentTime
        selfFinanceRequested
        contractType
        source
        status
        statusNote
        userLoadNumber
        purchaseOrderNumber
        factored
        nonFactoredType
        MinimumFee
        paymentMethod
        fuelAdvancePaymentMethod
        amountFunded
        attachments {
          id
          filename
          downloadUrl
          category
          visibleTo
        }
        debtor {
          created
          modified
          id
          email
          noaContactEmail
          paymentStatusEmail
          name
          companyName
          address
          phoneNumber
          faxNumber
          mc
          dot
          taxId
          avgpay
          creditApproved
          creditApprovedNote
          creditLimit
          originalsRequired
          dtpAllowance
          discountRate
          dunsNumber
        }
        paymentStatus
        paymentProfilePaymentMethod
        paymentProfileDiscountRate
        paymentProfileFundedAt
        factoringAmount
        factoringFeeSplitRate
        fuelAdvanceFeeSplitRate
        reserveHoldbackRate
        carrierProNumber
        reserveHoldback
        selectedFeeSplit
        applyReserveHoldback
        paymentProfileAmount
        payoutDays
        invoiceDate
        frType
        clientInvoiceNumber
        paymentProfile {
          companyName
        }
        factoringDebtorRelation {
          id
          noaSent
          noaPlaced
          noaActive
          noaRequested
          creditApproved
        }
        amountFunded
        factoring {
          id
          companyProfile
          ownerProfile
          factoringApproved
          discountRate
          marginDiscountRate
          attachments
          noaAttachments
          MinimumFee
          brokerApproved
          fuelAdvance
          fuelAdvanceRate
          fuelAdvanceFee
          fuelAdvanceLimit
          enableDiscount
          showDebtorDeclined
          createNonFactoredFr
          reserveHoldback
          reserveHoldbackRate
          nonFactoredFee
          allowNegativeMargin
          negativeMarginValue
          negativeMarginLimit
          enableReserveHoldbackHybrid
          defaultEnableReserveHoldback
          sendRateConfirmationRemoteApproved
          allowSelfFinanceFr
          stripeEnabled
          selfFinanceFrLimit
          selfFinanceRolling30DayFrLimit
          selfFinanceApprovalWithoutNoa
          companySettings
          enabledContractTypes
        }
      }
    }
  }
`;

export const QUERY_FUNDING_REQUEST_SUMMARY = gql`
  query MyQuery(
    $debtor: String
    $assignedLoads: Boolean
    $userLoadNumber: String
    $invoiceNumber: String
    $loadOrInvoiceOrDebtorOrStatus: String
    $contractType: String
    $status: String
  ) {
    fundingRequestsSummary(
      debtor: $debtor
      assignedLoads: $assignedLoads
      userLoadNumber: $userLoadNumber
      invoiceNumber: $invoiceNumber
      loadOrInvoiceOrDebtorOrStatus: $loadOrInvoiceOrDebtorOrStatus
      contractType: $contractType
      status: $status
    ) {
      data
    }
  }
`;
